module.exports = __webpack_public_path__ + "img/rock-huge-16.5b81a9d2.png";